const telephones: { id: number; location: string; telephone: string }[] = [
  { id: 1, location: null, telephone: '900 922 922' },
  { id: 2, location: null, telephone: '677 007 000' },
]

export default telephones
